export default function CtaSection() {
  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 rounded-3xl overflow-hidden bg-background-50">
          <div className="relative h-72 md:h-[420px] lg:h-auto overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Fashion%20shopping%20inspiration%20flat%20lay%20with%20stylish%20accessories%20sunglasses%20wallet%20and%20phone%20on%20soft%20peach%20linen%20background%2C%20warm%20golden%20afternoon%20sunlight%2C%20modern%20editorial%20product%20photography%2C%20aspirational%20lifestyle%20aesthetic%20with%20gentle%20shadows%20and%20relaxed%20composition%2C%20subtle%20luxury%20vibe%20with%20neutral%20warm%20tones&width=800&height=600&seq=cta-v2-split-z40&orientation=landscape"
              alt="Latest AllChinaBuy Spreadsheet finds 2026"
              className="w-full h-full object-cover object-top"
              loading="lazy"
            />
            <div className="absolute top-6 left-6">
              <span className="inline-block px-3 py-1 text-xs font-semibold text-background-50 bg-foreground-900/60 rounded-full backdrop-blur-sm">
                Latest 2026
              </span>
            </div>
            <div className="absolute bottom-6 left-6">
              <p className="font-heading text-3xl md:text-4xl font-bold text-background-50 leading-tight drop-shadow-lg">
                Best<br />AllChinaBuy<br />Spreadsheet
              </p>
            </div>
          </div>

          <div className="flex flex-col items-center justify-center text-center px-8 py-12 md:py-16">
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-4">
              Start Exploring Today
            </h2>
            <p className="text-foreground-600 text-sm md:text-base max-w-sm mb-8 leading-relaxed">
              Browse categories, compare products, and discover the most popular finds from our <strong>AllChinaBuy spreadsheet</strong> — all updated daily for the best shopping experience.
            </p>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-8 py-3.5 text-sm font-semibold bg-primary-500 text-background-50 dark:text-foreground-950 rounded-full hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
            >
              Browse Spreadsheet
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}